/* 
Common code for each of the views making up the levy collection provider page.
*/
import lookupMixins from "@/mixins/lookup.mixins";
import * as lcAction from "@/store/levy-collections/action-types";
import * as lcpAction from "@/store/levy-collection-providers/action-types";

export default {
  mixins: [lookupMixins],
  computed: {
    levyCollectionId() {
      return parseInt(this.$route.params.levyCollectionId);
    },
    providerId() {
      return parseInt(this.$route.params.providerId);
    },
    levyCollection() {
      return this.$store.state.levyCollections.view.data;
    },
    isSandbox() {
      return this.doesLookupHaveAttribute(this.levyCollection.type, "IsSandbox", this.lookups.levyCollectionTypes);
    },
    levyCollectionLoaded() {
      return this.$store.state.levyCollections.view.loaded;
    },
    state() {
      return this.$store.state.levyCollectionProviders.view;
    },
    provider() {
      return this.state.data;
    },
    providerLoaded() {
      return this.state.loaded;
    },
    breadcrumbs() {
      if (!this.providerLoaded) {
        return [
          {
            text: "Levy collection providers",
            path: `/levy-collections/${this.levyCollectionId}/providers`
          },
          { text: "..." }
        ];
      }
      return [
        {
          text: `${this.provider.levyCollectionDescription}${!this.isSandbox ? " levy collection" : ""} providers`,
          path: `/levy-collections/${this.levyCollectionId}/providers`
        },
        {
          text: this.provider.providerName
        }
      ];
    },
    title() {
      return this.provider.providerName ? `${this.provider.providerName} (${this.provider.providerCode})` : "...";
    },
    subtitle() {
      return this.provider.status && !this.isSandbox
        ? this.lookups.levyCollectionProviderStatusDescriptions[this.provider.status]
        : null;
    },
    arrivedFromListing() {
      return (
        this.$store.state.levyCollectionProviders.listing.loaded &&
        this.$store.state.levyCollectionProviders.levyCollectionId == this.levyCollectionId
      );
    },
    nextPageAction() {
      return lcpAction.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return lcpAction.LIST_PREVIOUS_PAGE;
    }
  },
  mounted() {
    this.refresh();
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    providerId() {
      this.refresh();
    },
    levyCollectionLoaded() {
      this.refresh();
    },
    providerLoaded() {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      this.$store.dispatch(lcAction.VIEW_REFRESH, this.levyCollectionId);
      this.$store.dispatch(lcpAction.VIEW_REFRESH, {
        levyCollectionId: this.levyCollectionId,
        providerId: this.providerId
      });
    }
  }
};
